import React, { Component } from 'react';
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import { Mainmenu } from './Mainmenu';
import $ from 'jquery';
import './../../src/assets/js/menuCustom.js';
import logoBewise from './../assets/images/bewise-logo-new.png';
import Sidebar from "react-sidebar";
import config from '../API/DomainName';
import ReactTooltip from "react-tooltip";
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import {
  social_login, userLogin, userSignUp, userUpdate, getUser,
  postQuery, LocationData, GetLocationData, verifyEmail, reSendVerify
} from '../API/FetchCall';
import { Headsearch } from './head_search';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import Rating from 'react-star-rating-component';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import InstagramLogin from 'react-instagram-login';

import { Helmet } from 'react-helmet';
//import swal from 'sweetalert';
import Autosuggest from 'react-autosuggest';

import Recaptcha from 'react-recaptcha';
import { BASE_URL, GOOGLE_CAPTCHA_SITE_KEY, GOOGLE_LOGIN_CLIENT_ID, LINKEDIN_CLIENT, FACBEOOK_APP_ID, LINKEDIN_SECRET } from '../constant';


class HeaderV1 extends Component {
  constructor(props) {
    super(props);
    let isLoginPage = window.location.pathname;
    let islogin = localStorage.getItem('logged_auth');
    if ((isLoginPage == '/login' || isLoginPage == '/signup') && islogin == 'true') {
      window.location.replace('/');
    }
    this.state = {
      isResenfVerify: false,
      tuser_id: 0,
      PageTitle: 'Bewise',
      triggerLoginModal: this.props.login,
      login_type: 1,
      login_type_name: '',
      q_type: '',
      l_emailid: '',
      l_password: '',
      q_name: '',
      q_email_id: '',
      q_comments: '',
      q_phone_no: '',
      q_subject: '',
      first_name: '',
      last_name: '',
      authe: false,
      editData: false,
      showModalLogin: isLoginPage == '/login' ? true : false,
      showModalSignup: isLoginPage == '/signup' ? true : false,
      currentLocation: '/',
      type_pass: 'password',
      type_pass_confirm: 'password',
      faicon_pass: 'fa fa-fw fa-eye-slash field-icon',
      faicon_pass_confirm: 'fa fa-fw fa-eye-slash field-icon',
      errors: [],
      reg_name: '',
      reg_mobile: '',
      reg_email: '',
      reg_child_name: '',
      reg_child_age: '',
      reg_password: '',
      reg_confirmpassword: '',
      suggestions: [],
      cur_page: '/signin?prev_path=' + window.location.pathname,
      value: localStorage.getItem("searchdata") ? localStorage.getItem("searchdata") : '',
      searchList: [],
      sidebarOpen: false,
      showLocationPop: false,
      location_list: [],
      location_lists: [],
      isLoading: true,
      location: [],
      error: null,
      signupbtn: false,
      signupbtnTxt: 'Sign Up',
      showPassword: false,
      agree_data: '',
      currlocation: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'Bengaluru',
      isValidCaptcha: false,
      formValues: [{ child_name: "", child_age: "", child_scl: "", child_city: "" }]
    };
    this.validator = new SimpleReactValidator({
      validators: {
        password_custome: {  // name the rule
          message: 'The :attribute must be a Min of 8 characters in length – One Capital Letter, One Number, One Character.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        password_customeE: {  // name the rule
          message: 'The :attribute must be a Min of 8 characters in length – One Capital Letter, One Number, One Character.',
          rule: (val, params, validator) => {
            if (val) {
              return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        confirmpassword: {  // name the rule
          message: 'The :attribute must be Same as Password.',
          rule: (val, params, validator) => {
            if (val != this.state.reg_password) {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        }
      },
      autoForceUpdate: this
    });
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }


  componentDidMount() {
    this.LocationDataList();
    var cur_page = '/signin' + window.location.pathname;
    var This = this;
    navigator.geolocation.getCurrentPosition(function (position) {
      This.get_current_loaction(position.coords.latitude, position.coords.longitude, '');
    },
      function (error) {
        This.get_current_loaction('', '', error)
      });


    let qrystr = window.location.search;
    const urlParams = new URLSearchParams(qrystr);
    let tokenV = urlParams.get('token');
    let user_idV = urlParams.get('id');

    if (tokenV && user_idV) {
      let vdata = JSON.stringify({
        token: tokenV,
        user_id: user_idV
      })
      verifyEmail(vdata).then((response) => {
        let toastr = '';
        if (response.status == 1) {
          toastr = window.toastr.success;
          toastr(response.message, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          window.location.href = '/';
        } else {
          let er = response.message
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          window.location.href = '/';
        }
      });
    }
    let urlType = urlParams.get('type');
    if (urlType == 'linkedLogin') {
      let linkedState = urlParams.get('state');
      let authToken = urlParams.get('code');
      console.log('authTokenlinked', authToken);
      this.linkedinAuth(authToken, linkedState);
    }

    if (this.state.currlocation != '') {
      this.setState({
        current_location: this.state.currlocation ? this.state.currlocation : 'Bengaluru',
      });
    }


    var preschool = localStorage.getItem("preschool_compare") ? localStorage.getItem("preschool_compare") : '';
    var school = localStorage.getItem("school_compare") ? localStorage.getItem("school_compare") : '';
    var playarea = localStorage.getItem("playarea_compare") ? localStorage.getItem("playarea_compare") : '';
    var hobby = localStorage.getItem("hobby_compare") ? localStorage.getItem("hobby_compare") : '';
    var tution = localStorage.getItem("tution_compare") ? localStorage.getItem("tution_compare") : '';
    var camp = localStorage.getItem("camp_compare") ? localStorage.getItem("camp_compare") : '';
    var advice = localStorage.getItem("advice_compare") ? localStorage.getItem("advice_compare") : '';
    var event = localStorage.getItem("event_compare") ? localStorage.getItem("event_compare") : '';

    if (preschool != 0) {
      var preschool_compare = JSON.parse(preschool);
      this.setState({
        preschool_com_len: preschool_compare.length,
      });
    } else {
      this.setState({
        preschool_com_len: 0,
      });
    }
    if (school != 0) {
      var school_compare = JSON.parse(school);
      this.setState({
        school_com_len: school_compare.length
      });
    } else {
      this.setState({
        school_com_len: 0,
      });
    }
    if (playarea != 0) {
      var playarea_compare = JSON.parse(playarea);
      this.setState({
        playarea_com_len: playarea_compare.length
      });
    }
    else {
      this.setState({
        playarea_com_len: 0,
      });
    }

    if (hobby != 0) {
      var hobby_compare = JSON.parse(hobby);
      this.setState({
        hobby_com_len: hobby_compare.length,
      });
    } else {
      this.setState({
        hobby_com_len: 0,
      });
    }

    if (tution != 0) {
      var tution_compare = JSON.parse(tution);
      this.setState({
        tution_com_len: tution_compare.length,
      });
    } else {
      this.setState({
        tution_com_len: 0,
      });
    }

    if (camp != 0) {
      var camp_compare = JSON.parse(camp);
      this.setState({
        camp_com_len: camp ? camp_compare.length : 0,
      });
    } else {
      this.setState({
        camp_com_len: 0,
      });
    }

    if (advice != 0) {
      var advice_compare = JSON.parse(advice);
      this.setState({
        advice_com_len: advice_compare.length
      });
    } else {
      this.setState({
        advice_com_len: 0,
      });
    }
    if (event != 0) {
      var event_compare = JSON.parse(event);
      this.setState({
        event_com_len: event_compare.length
      });
    } else {
      this.setState({
        event_com_len: 0,
      });
    }
    let auth = localStorage.getItem("logged_auth");
    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
      let auth_data = JSON.parse(data_auth);
      let login_type_name = '';
      if (auth_data.login_type == 2) {
        login_type_name = 'Google';
      } else if (auth_data.login_type == 3) {
        login_type_name = 'Facebook';
      } else if (auth_data.login_type == 4) {
        login_type_name = 'LinkedIn';
      }
      this.setState({
        logged_name: auth_data.first_name + ' ' + auth_data.last_name,
        authe: true,
        user_id: auth_data.user_id,
        login_type: auth_data.login_type,
        login_type_name: login_type_name
      });
    }
    var currentLocation = window.location.pathname;
    this.setState({
      currentLocation: currentLocation,
    });
  }

  linkedinAuth = (token, statecode) => {
    var authpost = JSON.stringify({
      grant_type: 'authorization_code',
      code: token,
      client_id: LINKEDIN_CLIENT,
      client_secret: LINKEDIN_SECRET,
      redirect_uri: BASE_URL + '?type=linkedLogin',
    });
    let toastr = '';
    fetch(config.register + 'user/auth/linkedAuth', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: authpost,
    }).then(res => res.json()).then(res => {

      if (res.status === 1) {
        // let profile = { first_name: 'Sabarish', last_name: 'Smitiv', token: '4Ust8OR2La' };
        let profile = res.data;
        let emailid = res.data.emailelement.elements[0]['handle~'].emailAddress;
        var regData = JSON.stringify({
          token: profile.token,
          login_type: 4,//linkedin
          name: profile.first_name,
          last_name: profile.last_name,
          reg_mobile: '',
          email: emailid,
          reg_child_name: '',
          reg_child_age: '',
          reg_password: '',
          reg_confirmpassword: '',

        });
        this.socialLogin(regData);
      } else {
        toastr = window.toastr.error; //warning
        toastr('', res.message, {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      }
    })
  }
  get_current_loaction(latitude, longitude, error) {

    console.log('latitude', latitude)
    console.log('longitude', longitude)
    console.log('error', error)

    let current_location = localStorage.getItem("current_location") ? localStorage.getItem("current_location") : '';

    if (longitude && longitude) {
      if (current_location == "") {
        this.fetchIpLocation();
      }

    } else {
      this.setState({
        current_location: this.state.currlocation,
      });

    }

  }
  recaptchaLoaded = (e) => {
    // console.log('Successfully loaded');
  }
  verifyCallback = (response) => {
    if (response) {
      this.setState({
        isValidCaptcha: true,
      });
    }
  }
  fetchIpLocation() {
    fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(data =>
        this.setState({
          get_location: data,
          get_latitude: data.latitude,
          get_longitude: data.longitude,
          current_locations: 'Bengaluru',
          current_location: 'Bengaluru',
          isLoading: false,
        })
      )
      .catch(error => this.setState({ error, isLoading: false }));
  }

  LocationDataList = async () => {
    try {
      const res = await LocationData();
      if (res.status == 1) {
        this.setState({
          location_list: res.results,
          error: false
        });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };

  handle_signin = (e) => {
    e.preventDefault();
    this.setState({ showModalLogin: true, showModalSignup: false, isValidCaptcha: false });
  };
  handle_signup = (e) => {
    e.preventDefault();
    this.setState({ showModalLogin: false, showModalSignup: true, isValidCaptcha: false });

  };

  openPopup_signin = (e) => {
    e.preventDefault();
    this.setState({ showModalLogin: true, showModalSignup: false, isValidCaptcha: false });
  };

  openPopup_signup = (e) => {
    e.preventDefault();
    this.setState({ showModalLogin: false, showModalSignup: true, isValidCaptcha: false });
  };
  closePop = (e) => {
    e.preventDefault();
    this.setState({ showModalLogin: false, showModalSignup: false, isValidCaptcha: false });
  };
  componentDidUpdate() {
    const { showModalLogin, showModalSignup } = this.state;
    if (showModalLogin || showModalSignup) {
      setTimeout(function () {
        console.log('Juqery', $('.popmodal').find('div.modal-content'))
        $('.popmodal').find('div.modal-content').removeClass('modal-content');
      }, 100);

    }
  }

  shouldRenderSuggestions = (value, reason) => {
    return value.trim().length > 2;
  };
  getSuggestionValue(suggestion) {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }
  onSuggestionsFetchRequested = ({ value }) => {
    this.getSuggestions(value).then(response => {
      this.setState({
        suggestions: response
      });
    })
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  handleShowPasswordv1() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  handlelogin = (e) => {

    e.preventDefault();

    var cur_page = window.location.href;
    if (this.state.isResenfVerify == false) {
      let regData = JSON.stringify({
        login_type: 1,
        email_id: this.state.l_emailid,
        password: this.state.l_password,
      });


      userLogin(regData).then((response) => {

        if (response.status == 1) {
          ReactGA.event({
            category: "loginuser",
            action: "login | Success",
            label: "loginuser",
          });

          let userdata = {
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            user_id: response.data.user_id,
            email_id: response.data.email_id,
            mobile_no: response.data.mobile_no,
            login_type: response.data.login_type,
            isPartner: response.data.main_partner_id,
          }
          localStorage.setItem("logged_auth", true);
          localStorage.setItem('myData', JSON.stringify(userdata));
          document.getElementById("loginmessage").innerHTML = "Login successful";
          setTimeout(function () {
            if (cur_page != "")
              window.location.href = cur_page;
            else
              window.location.href = BASE_URL;
          }, 1000);

        } else {
          if (response.verify) {
            this.setState({
              isResenfVerify: response.verify,
              tuser_id: response.login_id,
            })
          }
          ReactGA.event({
            category: "loginuser",
            action: "login | failure",
            label: "loginuser",
          });
          document.getElementById("loginerrormessage").innerHTML = response.msg;
        }
      });
    } else {
      let req = JSON.stringify({
        login_type: 1,
        email_id: this.state.l_emailid,
        login_id: this.state.tuser_id,
      });
      reSendVerify(req).then((res) => {
        this.setState({
          isResenfVerify: false,
          tuser_id: 0,
        });
        let toastr = '';
        if (res.status === 1) {
          toastr = window.toastr.success;
        } else {
          toastr = window.toastr.error;
        }
        toastr('', res.message, {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      });
    }


  };

  handle_signup_edit = (e) => {
    let data_auth = JSON.parse(localStorage.getItem("myData"));
    let vdata = JSON.stringify({
      user_id: data_auth.user_id
    });
    console.log('*** her e', data_auth.user_id);
    getUser(vdata).then((response) => {
      if (response.status === 1) {
        let a = response.result;
        this.setState({
          first_name: a.first_name,
          last_name: a.last_name,
          reg_mobile: a.mobile_no,
          reg_email: a.email_id,
          reg_child_name: a.child_name,
          reg_child_age: a.child_age,
          shmodelEditData: true,
          editData: true,
          isValidCaptcha: false
        });
      }
    });
  };
  editclose = (e) => {
    this.setState({
      irst_name: '',
      last_name: '',
      reg_mobile: '',
      reg_email: '',
      reg_child_name: '',
      reg_child_age: '',
      shmodelEditData: false,
      editData: false
    });
  };

  locationPop = (e) => {
    this.setState({ showLocationPop: false });
  };
  loginclose = (e) => {
    this.setState({ showModalLogin: false });
  };

  loginopen = (e) => {
    this.setState({ showModalLogin: true });
  };

  signupclose = (e) => {
    this.setState({ showModalSignup: false });
  };

  signupopen = (e) => {
    this.setState({ showModalSignup: true });
  };
  handleChange_chld(i, e) {
    let formValues = this.state.formValues;
    formValues[i][e.target.name] = e.target.value;
    this.setState({ formValues });
  }
  removeFormFields(i) {
    let formValues = this.state.formValues;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }
  addFormFields() {
    let child_data = JSON.stringify(this.state.formValues);
    var stringify = JSON.parse(child_data);
    var cnt = stringify.length;
    if (cnt > 9) {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('Maximum 10 children are allowed!', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
    } else {
      this.setState(({
        formValues: [...this.state.formValues, { child_name: "", child_age: "" }]
      }))

    }
  }
  handleSubmit = (e) => {
    //alert('A name was submitted: ' + this.state.values.join(', '));
    let child_data = JSON.stringify(this.state.formValues);
    var stringify = JSON.parse(child_data);
    for (var i = 0; i < stringify.length; i++) {
      console.log(stringify[i]['child_name']);
      console.log(stringify[i]['child_age']);
    }
    //let childDats = JSON.parse(child_data);
    e.preventDefault();
    let toastr = '';
    if (this.validator.allValid() && this.state.isValidCaptcha) {

      this.setState({
        signupbtnTxt: 'Please Wait...',
        signupbtn: true
      });
      var regData = JSON.stringify({
        logintype: 1,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        reg_mobile: this.state.reg_mobile,
        reg_email: this.state.reg_email,
        reg_city: this.state.reg_city,
        reg_child_name: child_data,
        reg_child_age: this.state.reg_child_age,
        reg_password: this.state.reg_password,
        reg_confirmpassword: this.state.reg_confirmpassword,
      });

      userSignUp(regData).then((response) => {

        if (response.status == 1) {
          // toastr = window.toastr.success;
          // toastr('Success', 'Successfully Registered! </br>Your Activation link  has been sent your to registered email id please click the link to activate your account. </br>(Check your SPAM folder too)', {
          //   positionClass: "toast-bottom-center",
          //   containerId: "toast-bottom-center"
          // });
          var myhtml = document.createElement("div");

          myhtml.innerHTML = `<p><b>Please verify your email</b></p>
          <p>Review one institution you have interacted with, from the Homepage.<p>
          <p>Automatically enter the <span class="boldblue">'Book Bonanza - Be Lucky, Get Booky' </span> event.</p>
          <p><span class="boldblack">Good luck!</span></p>`;

          /*
          myhtml.innerHTML = `<h5><b>Please verify your email</b></h5>
          <p>For free downloads, scroll to end of home page<p>
          <p><img src='assets/icons/Popup-footer.png'></p>`;
          */
          swal({
            content: myhtml,
            // html: true,
            // text: "Please verify your email! <br> For free downloads, scroll to end of home page",
            icon: "success",
            button: "Okay!",
          }).then((value) => {
            window.location.href = '/'
          });
          // setTimeout(function () {
          //   window.location.href = '/';
          // }, 1000);

        } else {
          this.setState({
            signupbtnTxt: 'Sign Up',
            signupbtn: false
          });
          let er = response.errors[0].msg
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
        }
      });
    } else {
      this.validator.showMessages();
    }

  };
  handleChange = (e) => {
    if (e.target.name == 'ind_agree') {
      this.setState({
        agree_data: 'checked',

      });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.clearValidationErr(e.target.name);
  };

  handlechange_location = (e) => {
    let current_location = e.target.value;
    if ((current_location != 'Bengaluru' && current_location != 'Chennai' && current_location != 'Hosur')) {
      this.setState({
        showLocationPop: true
      })
    } else {
      this.setState({
        current_location: e.target.value,
        current_locations: e.target.value,
      });
      let check_location = this.state.location_list.filter(o => o.location == current_location);
      localStorage.setItem("current_location", current_location);
      let lat = check_location[0].latitude;
      let lng = check_location[0].longitude;
      localStorage.setItem("latitude", lat);
      localStorage.setItem("longitude", lng);

      var urltoredirect = window.location.href;
      //alert(urltoredirect);
      const urlparts = urltoredirect.split("/");
      //console.log(urlparts);
      if(urlparts[4]=='schools' || urlparts[4]=='pre-schools'  || urlparts[4]=='kids-play-area' || urlparts[4]=='learning-camps' || urlparts[4]=='community-support' || urlparts[4]=='birthday-event' || urlparts[4]=='tuitions' || urlparts[4]=='after-school-activity'){
      let makeurl = "https://www.bewise.in/"+current_location.toLowerCase()+"/"+urlparts[4];
      if(urlparts[5]!== undefined){
        makeurl = makeurl+"/"+urlparts[5];
      }
      //alert(makeurl);
      window.location.href = makeurl;
      }
      else
      window.location.reload();
    }

  }

  locationList(location_select = '') {
    let locate = this.state.location_list !== undefined ? this.state.location_list : [];
    let check_location = this.state.location_list.filter(o => o.location == this.state.current_locations);
    let selected_name = '';
    if (location_select && this.state.location_list.length > 0) {
      selected_name = this.state.location_list.filter(o => o.location == location_select);
      if (selected_name.length > 0) {
        selected_name = selected_name ? selected_name[0]['location'] : '';
      }
    }
    if (this.state.current_locations != undefined) {
      localStorage.setItem("current_location", this.state.current_locations);

      if (check_location.length == 0) {
        locate.push({
          location: this.state.current_locations,
        });

      } else {
        console.log('already added')
      }
    }
    let rows = "";
    if (locate.length > 0) {
      rows = locate.map((locate, index) => {
        let select = (selected_name == locate.location) ? 'selected' : '';
        return (
          <option key={index} value={locate.location} selected={select} >{locate.location}</option>
        );
      });

    } else {
      rows = "";
    }
    return rows;
  }

  addlocation(locate) {

    let check_location = this.state.location_list.filter(o => o.location == this.state.current_locations);
    if (check_location.length == 0) {
      let locationData = JSON.stringify({
        location: locate,
      });
      GetLocationData(locationData).then((response) => {
        if (response.status == 1) {
          console.log(response.status);
          alert(1)
        } else {
          // console.log(response.status)
        }
      });
    }
  }


  handleRegPwd = (e) => {
    this.setState({ reg_password: e.target.value });
    this.clearValidationErr('reg_password');
  };
  handleRegCnfmPwd = (e) => {
    this.setState({ reg_confirmpassword: e.target.value });
    this.clearValidationErr('reg_confirmpassword');
  };
  handleShowPassword(type) {
    var oldState = type;
    var isTextOrHide = oldState === 'password';
    var newState = isTextOrHide ? 'text' : 'password';
    let icon = '';
    if (type === 'text') {
      icon = 'fa fa-fw fa-eye-slash field-icon';
    } else if (type === 'password') {
      icon = 'fa fa-fw fa-eye field-icon';
    }
    this.setState({
      type_pass: newState,
      faicon_pass: icon,
    });
  }
  handleShowConfirm(type) {
    var oldState = type;
    var isTextOrHide = oldState === 'password';
    var newState = isTextOrHide ? 'text' : 'password';
    let icon = '';
    if (type === 'text') {
      icon = 'fa fa-fw fa-eye-slash field-icon';
    } else if (type === 'password') {
      icon = 'fa fa-fw fa-eye field-icon';
    }
    this.setState({
      type_pass_confirm: newState,
      faicon_pass_confirm: icon,
    });
  }


  handleChangefeedback = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    //console.log(e.target.name,e.target.value)
  };
  showValidationErr(elm, msg) {
    this.setState((prevState) => ({
      errors: [...prevState.errors, { elm, msg }],
    }));
  }
  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    });
  }


  isPasswordValid = () => {
    var password = this.state.reg_password;
    var passlength = password.length;
    var paswd = /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
    if (password.match(paswd)) {
      return true;
    } else {
      this.showValidationErr("reg_password", "Min of 8 characters in length – One Capital Letter, One Number, One Special Character")
      return false;
    }
  };

  isEmailValid = () => {
    var password = this.state.reg_email;
    var paswd = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
    if (password.match(paswd)) {
      return true;
    } else {
      this.showValidationErr("reg_email", "Enter Valid Email")
      return false;
    }
  };

  prepareLoginButton = (response) => {
    // console.log('response', response)
    // return false;
    let profile = response.profileObj;
    var regData = JSON.stringify({
      g_token: response.tokenId,
      token: profile.googleId,
      login_type: 2,
      name: profile.givenName,
      last_name: profile.familyName,
      reg_mobile: '',
      email: profile.email,
      reg_child_name: '',
      reg_child_age: '',
      reg_password: '',
      reg_confirmpassword: '',

    });
    this.socialLogin(regData);
  }

  socialLogin(regData) {
    social_login(regData).then((response) => {
      // console.log('status', response.status)
      let toastr = '';
      if (response.status == 1) {

        this.setState({
          showModalLogin: false,
          showModalSignup: false,
          l_emailid: '',
          l_password: '',
          authe: true,
          logged_name: response.data.first_name,
        })
        let userdata = {
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          user_id: response.data.user_id,
          login_type: response.data.login_type,
        }
        localStorage.setItem("logged_auth", true);
        localStorage.setItem('myData', JSON.stringify(userdata));


        toastr = window.toastr.success;
        toastr('', 'Login success!..', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
        // this.props.history.push('/preschoolslist');
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      } else {
        toastr = window.toastr.error; //warning
        toastr('', response.message, {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      }
    });
  }

  onStarClickfeedback(nextValue, prevValue, name) {
    this.setState({ rating: nextValue });
  }
  onStarClick1feedback(nextValue, prevValue, name) {
    this.setState({ rating1: nextValue });
  }
  handleQueryfeedback = (e) => {
    e.preventDefault();
    var emailtext = JSON.stringify({
      rating: this.state.rating,
      rating1: this.state.rating1,
      feature: this.state.feature,
      decision: this.state.decision,
      verticals: this.state.verticals,
      suggession: this.state.suggession,
      message: this.state.message
    });
    //console.log("email text",emailtext)
    let result = fetch(config.register + 'user/auth/sendfeedback', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: emailtext,
    });
    let toastr = '';
    toastr = window.toastr.success;

    toastr('', 'Thanks for your Feedback!..', {
      positionClass: "toast-bottom-center",
      containerId: "toast-bottom-center"
    });
    window.$('#feedBackModal').modal('hide');
    $('.modal-backdrop').removeClass("show");
    setTimeout(function () {
      window.location.reload();
    }, 1000);
  }


  handleQuery = (e) => {
    e.preventDefault();

    if (
      this.state.q_comments != '' && this.state.q_name != '' && this.state.q_type != '' &&
      this.state.q_subject != '') {
      let regData = JSON.stringify({
        user_id: this.state.user_id ? this.state.user_id : 0,
        q_type: this.state.q_type,
        name: this.state.q_name,
        email_id: this.state.q_email_id,
        subject: this.state.q_subject,
        phone_no: this.state.q_phone_no,
        comments: this.state.q_comments,
        user_type: this.state.user_type,
      });
      // let result = fetch(config.register + 'user/auth/contactus', {
      //   method: 'POST',
      //   mode: 'cors',
      //   headers: {
      //     'Content-Type': 'application/json; charset=UTF-8'
      //   },
      //   body: regData,
      // });
      postQuery(regData).then((response) => {
        let toastr = '';
        if (response.status == 1) {
          $('#postQueryModal').hide('');
          $('.modal-backdrop fade').removeClass('show');
          this.setState({
            name: '',
            email_id: '',
            subject: '',
            phone_no: '',
            comments: '',
          })
          toastr = window.toastr.success;
          toastr('', 'Thanks for your query!..', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        } else {
          toastr = window.toastr.error; //warning
          toastr('', 'Required!...', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
        }
      });
    } else {
      let toastr = '';
      if (this.state.q_name == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Name Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_type == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Query type Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_email_id == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Email. Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_subject == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Subject Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      } else if (this.state.q_comments == '') {
        toastr = window.toastr.error; //warning
        toastr('Error', 'Comments Required!...', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      }

    }
  };

  logoutSess(e) {
    localStorage.clear();
    let toastr = '';
    toastr = window.toastr.success;
    toastr('Logout successful', {
      positionClass: "toast-bottom-center",
      containerId: "toast-bottom-center"
    });
    setTimeout(function () {
      window.location = "/";
    }, 2000);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.login === true) {
      // window.location.href = '/signin';
      this.setState({
        showModalLogin: true,
      })
    } else if (nextProps.signup === true) {
      // window.location.href = '/signup_parent';
      this.setState({
        showModalSignup: true,
      })
    }
  }

  render() {
    const { rating, rating1 } = this.state;
    this.validator.purgeFields();


    const compare = this.state.preschool_com_len + this.state.school_com_len + this.state.playarea_com_len + this.state.hobby_com_len + this.state.tution_com_len + this.state.camp_com_len + this.state.advice_com_len + this.state.event_com_len;

    $(function () {
      $('#main-menu').smartmenus({
        subMenusSubOffsetX: 1,
        subMenusSubOffsetY: 5
      });
    });

    const pageUrl = window.location.href;


    return (
      <React.Fragment>

        <Helmet>
             <link rel="canonical" href={pageUrl} />
        </Helmet>

        <header style={{
          position: "sticky",
          zIndex: "999",
          background: "#fff",
          width: "100%",
          top: 0
        }}
        >

          {/* <div className="text-center this-test-site">
            <span className="blink_me">
              This is a test site with SAMPLE DATA only. Quality data / more locations / cities will follow soon.
              </span> 
          </div> */}
          <Modal isOpen={this.state.showLocationPop} centered size='lg'>
            <ModalBody className='p-0'>
              <button
                className='close-btn'
                data-dismiss='modal'
                aria-label='Close'
                onClick={this.locationPop}
              >
                <img src={BASE_URL + 'assets/icons/close.svg'} alt='close' />
              </button>
              <div className=''>
                <Row className='m-5 text-center'>
                  <Col sm={{ size: 12 }} className=''>
                    <div className=''>
                      <h4>Coming soon to your city. Stay tuned!</h4>
                    </div>
                  </Col>
                </Row>
              </div>
            </ModalBody>
          </Modal>

          <div className='tranparent-header-custom-inner'>
            <div className='container-fluid'>
              <div className='row align-items-center header-custom'>
                <div className='col-lg-4 col-md-4 col-12'>
                  <div className='bewise-logo active'>
                    <div class="row">
                      <div>
                        <a className='logo-text' href='/'>
                          <img src={logoBewise} style={{ width: "55px", marginRight: "2px" }} />
                        </a>
                      </div>
                      <div>
                        <h5 style={{ lineHeight: "3px", marginTop: "10px", fontWeight: "bold", transform: "scale(1, 1.1)" }}>BeWise</h5>
                        <p style={{ fontSize: "8px", fontWeight: "bold", transform: "scale(.75, 1)", marginLeft: "-10px" }}>Enabling Learning & Fun</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 col-md-4 col-12 text-right hd-mid'>
                  <div className='nav-search-fill'>
                    <form
                      name='search_form'
                      id='search_form'
                      method='POST'
                      action='search'
                    >
                      <div className='search-category'>
                        <select className='nav-custom-select'
                          value={this.state.currlocation} name="current_location"
                          onChange={this.handlechange_location}
                        >
                          {this.locationList(this.state.current_location)}

                        </select>
                      </div>
                      <Headsearch />

                    </form>
                  </div>
                </div>
                <div className='col-lg-4 col-md-4 text-right mobile-position'>


                  {/* <div className="wishlist">
                  {(this.state.authe === false) ?
                  (
                    <a className="" onClick={this.handle_signin}> 
                    <span>Wishlist</span>&nbsp;<i className="fa fa-heart-o" aria-hidden="true"></i>
                    </a>
                  ):
                    (
                    <a className="" href="/wishlist"> 
                    <span>Wishlist</span>&nbsp;<i className="fa fa-heart-o" aria-hidden="true"></i>
                    </a>
                    )
                    }
                  </div> */}


                  {(this.state.authe === false) ?
                    <button className="sidebar-btn signin-name" onClick={() => this.onSetSidebarOpen(true)}>
                      <span>Sign In / Sign Up</span>  </button>
                    :
                    <button className="sidebar-btn signin-name" onClick={() => this.onSetSidebarOpen(true)}>
                      <span className="signned-name">{this.state.logged_name}</span> <i className="fa fa-bars" aria-hidden="true"></i>  </button>
                  }

                </div>
                <div className="sidebar-custom-menu">
                  <Sidebar
                    sidebar={
                      <div className="sidebar-right">
                        <button className="sidebar-btn-close" onClick={() => this.onSetSidebarOpen(false)}> <i className="fa fa-times" aria-hidden="true"></i>  </button>
                        {/* <div className="sign-username-section">
                          {(this.state.authe === false) ?
                            <div className='signin' onClick={this.handle_signin}>
                              <span>Sign In</span>
                            </div>
                            :
                            <div className="navbar signin">
                              <div className="nav-item dropdown">
                                <a className="dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <span>{this.state.logged_name}</span>
                                </a>
                              </div>
                            </div>
                          }
                        </div> */}
                        <ul>
                          {(this.state.authe === true) ?
                            (
                              <div>
                                <li>
                                  <div className="wishlist">
                                    <a href="javascript:;">
                                      {this.state.logged_name}
                                    </a>
                                    {this.state.login_type_name && <p><small>logged in through {this.state.login_type_name}</small></p>}
                                  </div>
                                </li>
                                <li>
                                  <div className="wishlist">
                                    <a href="/edit_profile" target="_blank" >
                                      Edit Profile
                                    </a>
                                  </div>
                                </li>
                                <li>
                                  <div className="wishlist">
                                    <a href="/wishlist"> <span>Wishlist</span></a>
                                  </div>
                                </li>
                              </div>
                            )
                            : (
                              <div>
                                {/*<li>
                                  <div className="wishlist">
                                    <a href={this.state.cur_page}>
                                     <a href="/signin" target="_blank" onClick={this.handle_signin}> */}
                                {/*  Sign In
                                    </a>
                                  </div>
                                </li>
                                <li>
                                  <div className="wishlist">
                                    <a href="/signup_parent">
                                      Sign Up
                                    </a>
                                  </div>
                                </li> */}

                                <li>
                                  <div className="wishlist">
                                    {/* <a className="" data-toggle="modal" data-target="#signInModal"> */}
                                    <a href="" onClick={this.handle_signin}>
                                      Sign In
                                    </a>
                                  </div>
                                </li>
                                <li>
                                  <div className="wishlist">
                                    {/* <a className="" data-toggle="modal" data-target="#signUpModal"> */}
                                    <a href="" onClick={this.handle_signup}>
                                      Sign Up
                                    </a>
                                  </div>
                                </li>
                              </div>
                            )}

                          <li>
                            <div className="wishlist">
                              <a href="" onclick="ga(‘send’, ‘event’, ’Reach us’, 'Reach us', ‘label’, value, {‘NonInteraction’: 1});"
                                data-toggle="modal" data-target="#postQueryModal">Contact us</a>
                            </div>
                          </li>
                          {(this.state.authe === true) ?
                            <li>
                              <div className="wishlist">
                                <a href="/compare-list">

                                  {/* <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none" /><path d="M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" fill="#099C93" /></svg> */}
                                  <span >Compare</span>&nbsp;

                                  {(compare != 0) ?
                                    <span class="compare_count">{compare}</span> : ''}
                                  {/* <i class="fa fa-info-circle" data-tip data-for="registerTip"></i> */}

                                </a>
                              </div>
                            </li>
                            : ''}
                          {(this.state.authe === true) ?
                            <li>
                              <div className="wishlist">
                                <a href="javascript:;" onClick={(e) => this.logoutSess(e)}>
                                  {/* <img src={logout} /> */}
                                  Log out</a>
                              </div>
                            </li>
                            : ''}

                          {/* <li>
                            <div className='wishlist lang'>
                              <select className='lang-change'>
                                <option>English</option>
                              </select>
                            </div>
                          </li> */}


                        </ul>
                      </div>
                    }
                    open={this.state.sidebarOpen}
                    onSetOpen={this.onSetSidebarOpen}
                    sidebarClassName={"right-sidebar-custom"}
                    contentClassName={"sidebar-content"}
                    pullRight={true}
                    styles={{ sidebar: { background: "white" } }}
                  >
                  </Sidebar>
                </div>
              </div>
            </div>
          </div>
          <Mainmenu />

          {/* Post query button */}

          {/* <div className="post-query-btn" data-toggle="modal" data-target="#postQueryModal">
            <img className="blink-style ga-post-query" src={BASE_URL + 'assets/icons/post-query.png'} />
          </div> */}

          {/* <div className="post-query-btn" data-toggle="modal" data-target="#feedBackModal">
            <img className="blink-style ga-post-query" src={BASE_URL + 'assets/icons/post-query.png'} />
          </div> */}

          {/* <div className="post-query-btn contact-institution">   ///feed feedBackModal
            <img className="blink-style ga-post-query" src={BASE_URL+'assets/icons/whatsapp.png'} />
            </div> */}
          {/* Post  query button end */}

        </header>
        <Modal className='review-modal popmodal' isOpen={this.state.showModalLogin} size='lg'>
          {/* <div
          className='modal fade review-modal'
          id='signInModal'
        > */}
          <div className='modal-dialog model-box modal-md' >
            <div className='modal-content'>
              <div className='modal-header'>
                <h3 className='modal-title r-text'>Sign In</h3>
                <button
                  type='button'
                  className='close'
                  onClick={this.closePop}
                >
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>


              <div class="siginsignupform">

                <div className="text-center modallogo" ><img src={logoBewise} title="Bewise" /></div>
                <div class="sociallogin">

                  <div className="text-center social-icons mt-5 mb-3">
                    <div className='d-inline-block has-feedback'>
                      <div className="d-inline-block ">
                        <FacebookLogin
                          appId={FACBEOOK_APP_ID}
                          fields="name,email,picture"
                          callback={this.responseFacebook}
                          textButton=""
                          cssClass="my-facebook-button-class"
                          icon="fa-facebook"
                          isMobile={false}
                          render={renderProps => (
                            <button
                              className='btn btn-info btn-block btn-flat custom-fb-icon'
                              onClick={renderProps.onClick}>
                            </button>
                          )}
                        />
                      </div>
                    </div>
                    <div className='d-inline-block has-feedback centeredicon'>
                      <GoogleLogin
                        clientId={GOOGLE_LOGIN_CLIENT_ID}
                        render={renderProps => (
                          <div onClick={renderProps.onClick} disabled={renderProps.disabled}
                            className='c-pointer'>
                            <img src="/assets/icons/login-google.png" alt='google' style={{ width: '23px' }} />
                          </div>
                        )}
                        onSuccess={this.prepareLoginButton}
                        onFailure={this.prepareLoginButton}
                        cookiePolicy={'single_host_origin'}
                      />

                    </div>
                    <div className='d-inline-block has-feedback'>
                      <LinkedIn
                        clientId={LINKEDIN_CLIENT}
                        redirectUri={BASE_URL + "?type=linkedLogin"}
                        scope='r_liteprofile r_emailaddress'
                        renderElement={({ onClick, disabled }) => (
                          <div onClick={onClick} disabled={disabled} className='google-plus-icon linkedin-icon c-pointer'>
                            <i className="fa fa-linkedin" aria-hidden="true"></i>
                          </div>

                        )}

                      ></LinkedIn>
                    </div>
                  </div>

                </div>


                <hr class="hr-text" data-content="OR"></hr>

                <div class="sitelogin">
                  <form id='loginForm' action="" method='post'
                    onSubmit={this.handlelogin}
                    autoComplete='off'>
                    <div className='form-group has-feedback'>
                      <label className='n7tr' >
                        Email ID/Mobile Number
                      </label>
                      <input
                        type='text'
                        name='l_emailid'
                        value={this.state.l_emailid}
                        required
                        onChange={this.handleChange}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group has-feedback'>
                      <label className='n7tr' >
                        Password
                      </label>
                      <input
                        value={this.state.l_password}
                        onChange={this.handleChange}
                        type={this.state.showPassword ? 'text' : 'password'}
                        required
                        name='l_password'
                        className='form-control'
                      />
                      <span
                        toggle='#password-field'
                        className={this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon'}
                        onClick={() => {
                          this.handleShowPasswordv1();
                        }}
                      ></span>
                    </div>
                    {this.state.isResenfVerify == false ?
                      (<div className='form-group has-feedback'>
                        <input
                          type='submit'
                          name='submit'
                          value='Login'
                          className='submit btn btn-primary btn-block btn-flat bdr-15'
                        />
                      </div>
                      )
                      :
                      (
                        <React.Fragment>
                          <div className='form-group has-feedback'>
                            <button
                              type='submit'
                              name='submit'
                              className='submit btn btn-primary btn-block btn-flat bdr-15'>
                              <small>Resend Verification Link</small>
                            </button>
                          </div>
                          <p>If resend verification link is pressed more than once, the latest mail has to be chosen</p>
                        </React.Fragment>
                      )}

                  </form>
                  <div id="loginmessage" class="green centered"></div>
                  <div id="loginerrormessage" class="red centered"></div>
                </div>


              </div>
            </div>
          </div>
          {/* </div> */}
        </Modal>

        { /* signup form modal */}
        <Modal className='review-modal popmodal' isOpen={this.state.showModalSignup} size='lg'>
          {/* <div className='modal fade review-modal' id='signUpModal'> */}
          <div className='modal-dialog model-box modal-lg' >
            <div className='modal-content'>
              <div className='modal-header'>
                <h3 className='modal-title r-text'>Sign Up</h3>
                <button
                  type='button'
                  className='close'
                  onClick={this.closePop}
                >
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>


              <div class="siginsignupform">

                <div className="text-center modallogo" ><img src={logoBewise} title="Bewise" /></div>

                <div class="sociallogin">

                  <div className="text-center social-icons mt-5 mb-3">
                    <div className='d-inline-block has-feedback'>
                      <div className="d-inline-block ">
                        <FacebookLogin
                          appId={FACBEOOK_APP_ID}
                          fields="name,email,picture"
                          callback={this.responseFacebook}
                          textButton=""
                          cssClass="my-facebook-button-class"
                          icon="fa-facebook"
                          isMobile={false}
                          render={renderProps => (
                            <button
                              className='btn btn-info btn-block btn-flat custom-fb-icon'
                              onClick={renderProps.onClick}>
                            </button>
                          )}
                        />
                      </div>
                    </div>
                    <div className='d-inline-block has-feedback centeredicon'>
                      <GoogleLogin
                        clientId={GOOGLE_LOGIN_CLIENT_ID}
                        render={renderProps => (
                          <div onClick={renderProps.onClick} disabled={renderProps.disabled}
                            className='c-pointer'>
                            <img src="/assets/icons/login-google.png" alt='google' style={{ width: '23px' }} />
                          </div>
                        )}
                        onSuccess={this.prepareLoginButton}
                        onFailure={this.prepareLoginButton}
                        cookiePolicy={'single_host_origin'}
                      />

                    </div>
                    <div className='d-inline-block has-feedback'>
                      <LinkedIn
                        clientId={LINKEDIN_CLIENT}
                        redirectUri={BASE_URL + "?type=linkedLogin"}
                        scope='r_liteprofile r_emailaddress'
                        renderElement={({ onClick, disabled }) => (
                          <div onClick={onClick} disabled={disabled} className='google-plus-icon linkedin-icon c-pointer'>
                            <i className="fa fa-linkedin" aria-hidden="true"></i>
                          </div>

                        )}

                      ></LinkedIn>
                    </div>
                  </div>

                </div>


                <hr class="hr-text" data-content="OR"></hr>

                <div class="sitesignup">

                  <form
                    method='post'
                    onSubmit={this.handleSubmit}
                    autoComplete='off'
                    id='loginForm'
                  >
                    <div className='row'>
                      <div
                        className='col-md-6 form-group has-feedback'
                        style={{ width: '45%', float: 'left' }}
                      >
                        <label className='n7tr' >
                          First Name <span class="astrick">*</span>
                        </label>
                        <input
                          type='text'
                          name='first_name'
                          value={this.state.first_name}
                          onChange={this.handleChange}
                          className='form-control'
                        />
                        {this.validator.message('First Name', this.state.first_name, 'required|alpha', { className: 'text-danger' })}
                      </div>
                      <div
                        className='col-md-6 form-group has-feedback'
                        style={{ width: '45%', float: 'right' }}
                      >
                        <label className='n7tr' >
                          Last Name <span class="astrick">*</span>
                        </label>
                        <input
                          type='text'
                          name='last_name'
                          value={this.state.last_name}
                          onChange={this.handleChange}
                          className='form-control'
                        />
                        {this.validator.message('Last Name', this.state.last_name, 'required|alpha', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <label className='n7tr'>
                          Mobile Number <span class="astrick">*</span>&nbsp;
                          <i class="fa fa-info-circle" data-tip data-for="registerTip"></i>

                          <div className="App">
                            <ReactTooltip id="registerTip" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                              <p style={{ textAlign: "left" }}> BeWise requests your number for the following reasons: <br />(Sign up for parents)</p>


                              <p style={{ textAlign: "left" }}>1. Authentic and unique reviews and feedback associated <br />with registered parents</p>


                              <p style={{ textAlign: "left" }}>2. Communicate special deals offered by institutes/<br /> individuals relevant to parents</p>


                              <p style={{ textAlign: "left" }}>BeWise will not share your number with any person or <br />organization, under any circumstances. You retain the<br /> privacy and rights to choose who you wish to associate<br /> with to benefit from the information that is shared on<br /> the BeWise platform.</p>


                              <p style={{ textAlign: "left" }}>For more info, please go through privacy <br />policy.</p>

                            </ReactTooltip>
                          </div>
                        </label>
                        <input
                          type='number'
                          name='reg_mobile'
                          value={this.state.reg_mobile}
                          onChange={this.handleChange}
                          className='form-control'
                        />
                        {this.validator.message('Mobile Number', this.state.reg_mobile, 'required|numeric|min:10|max:10', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <label className='n7tr'>
                          Email ID <span class="astrick">*</span>
                        </label>
                        <input
                          type='text'
                          name='reg_email'
                          value={this.state.reg_email}
                          onChange={this.handleChange}
                          className='form-control'
                        />
                        {this.validator.message('Email ID', this.state.reg_email, 'required|email', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <label className='n7tr'>
                          City <span class="astrick">*</span>
                        </label>
                        <input
                          type='text'
                          name='reg_city'
                          value={this.state.reg_city}
                          onChange={this.handleChange}
                          className='form-control'
                        />
                        {this.validator.message('City', this.state.reg_city, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div
                        className='col-md-3 form-group has-feedback'
                        style={{ float: 'left' }}
                      >
                        <label className='n7tr' >
                          Child Name
                        </label>
                      </div>
                      <div
                        className='col-md-2 form-group has-feedback'
                        style={{ float: 'right' }}
                      >
                        <label className='n7tr'>
                          Age
                        </label>
                      </div>
                      <div
                        className='col-md-3 form-group has-feedback'
                        style={{ float: 'right' }}
                      >
                        <label className='n7tr'>
                          Scl/Pre-Scl Name
                        </label>
                      </div>
                      <div
                        className='col-md-3 form-group has-feedback'
                        style={{ float: 'right' }}
                      >
                        <label className='n7tr'>
                          City
                        </label>
                      </div>
                      <div
                        className='col-md-1 form-group has-feedback'
                        style={{ marginLeft: '-25px' }}
                      >
                      </div>
                      {/* {this.createUI()}     
                                <input type='button' value='Add more' onClick={this.addClick.bind(this)}/> */}
                      {this.state.formValues.map((element, index) => {
                        let scl_value = element.child_scl || "";
                        return (
                          <div className="row form-inline addmore" key={index}>
                            <div className='col-md-3'>
                              <input type="text" name="child_name"
                                placeholder='Child Name'
                                className="form-control child-styl" value={element.child_name || ""} onChange={e => this.handleChange_chld(index, e)} />
                            </div>
                            <div className='col-md-2'>
                              <input type="number"
                                placeholder='Age'
                                name="child_age" className="form-control child-styl" value={element.child_age || ""} onChange={e => this.handleChange_chld(index, e)} />
                            </div>
                            <div className='col-md-3 child_scl'>
                              <Autosuggest
                                suggestions={this.state.suggestions}
                                shouldRenderSuggestions={this.shouldRenderSuggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                onSuggestionSelected={(event, { suggestionValue }) => {
                                  console.log('suggestionValue', suggestionValue)
                                  let formValues = this.state.formValues;
                                  formValues[index]['child_scl'] = suggestionValue;
                                  this.setState({ formValues });
                                }}
                                inputProps={{
                                  className: "form-control child-styl ",
                                  placeholder: "Scl/Pre-Scl Name",
                                  value: scl_value,
                                  title: scl_value,
                                  name: "child_scl",
                                  onChange: e => {
                                    let formValues = this.state.formValues;
                                    formValues[index]['child_scl'] = e.target.value;
                                    this.setState({ formValues });
                                  }
                                }} />
                              {/* <input type="text"
                              placeholder='Scl/Pre-Scl Name'
                              name="child_scl" className="form-control child-styl" value={element.child_scl || ""} onChange={e => this.handleChange_chld(index, e)} /> */}
                            </div>
                            <div className='col-md-3'>
                              <input type="text"
                                placeholder='City'
                                name="child_city" className="form-control child-styl" value={element.child_city || ""} onChange={e => this.handleChange_chld(index, e)} />
                            </div>
                            {
                              index != 0 &&
                              <div className='col-md-1'>
                                <span className='remove' onClick={() => this.removeFormFields(index)}><i class="fa fa-trash" aria-hidden="true"></i></span>
                              </div>
                            }
                          </div>
                        )
                      }
                      )}
                      <div className="button-section">

                        <button className="btn btn-primary btn-sm add" type="button" onClick={() => this.addFormFields()}><i class="fa fa-plus" aria-hidden="true"></i></button>

                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <label className='n7tr'>
                          Password <span class="astrick">*</span>
                        </label>
                        <input
                          type={this.state.type_pass}
                          name='reg_password'
                          onChange={this.handleRegPwd}
                          className='form-control'
                        />
                        <span
                          toggle='#password-field'
                          className={this.state.faicon_pass}
                          onClick={() => {
                            this.handleShowPassword(this.state.type_pass);
                          }}
                        ></span>
                        {this.validator.message('Password', this.state.reg_password, 'required|password_custome', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <label className='n7tr'>
                          Confirm Password
                        </label>
                        <input
                          type={this.state.type_pass_confirm}
                          name='reg_confirmpassword'
                          onChange={this.handleRegCnfmPwd}
                          className='form-control'
                        />
                        <span
                          toggle='#password-field'
                          className={this.state.faicon_pass_confirm}
                          onClick={() => {
                            this.handleShowConfirm(
                              this.state.type_pass_confirm
                            );
                          }}
                        ></span>
                        {this.validator.message('Confirm Password', this.state.reg_confirmpassword, 'required|confirmpassword', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <Recaptcha
                          sitekey={GOOGLE_CAPTCHA_SITE_KEY}
                          render="explicit"
                          onloadCallback={this.recaptchaLoaded}
                          verifyCallback={this.verifyCallback}
                        />
                        {this.validator.message('Invalid Captcha', this.state.isValidCaptcha, 'required|boolean', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 form-group has-feedback'>
                        <label className="custom-checkboxs" style={{ marginTop: "10px" }}>
                          <label className='n7tr'>
                            <input type="checkbox" className=""
                              name="ind_agree"
                              value="Yes"
                              onChange={this.handleChange}
                              checked={this.state.agree_data} />
                            &nbsp;&nbsp; I Agree to <span style={{ color: "#1492E6" }}>
                              {/* <a href={BASEURL + "termsconditions"} target="_blank"> */}
                              <a href="javascript:window.open('/termsconditions', 'termsconditions', 'width=auto,height=auto')">
                                Terms of service
                              </a> and &nbsp;
                              {/* <a href={BASEURL + "privacypolicy"} target="_blank"></a> */}
                              <a href="javascript:window.open('/privacypolicy', 'privacypolicy', 'width=auto,height=auto')">
                                Privacy policy
                              </a>
                              <span class="astrick">*</span></span></label>

                          {/* <span className="checkmark"></span> */}
                        </label><br />
                        {this.validator.message('Agree', this.state.agree_data, 'required', { className: 'text-danger' })}
                      </div></div>
                    <div className='form-group has-feedback'>
                      <input
                        type='submit'
                        name='submit'
                        value={this.state.signupbtn ? 'Please Wait...' : 'Sign Up'}
                        disabled={this.state.signupbtn ? true : false}
                        className='submit btn btn-primary btn-block btn-flat bdr-15'
                      />
                    </div>
                  </form>
                  <div id="signupmessage" class="green centered"></div>
                  <div id="signuperrormessage" class="red centered"></div>
                </div>

              </div>
            </div>
          </div>
          {/* </div> */}
        </Modal>



        <div
          className='modal fade review-modal'
          id='feedBackModal'
        >
          <div className='modal-dialog model-box modal-md' >
            <div className='modal-content'>
              <div className='modal-header'>
                <h3 className='modal-title r-text'>Feedback</h3>
                <button
                  type='button'
                  className='close'
                  data-dismiss='modal'
                  aria-label='Close'
                >
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>
              <form method='post'
                autoComplete='off'
                onSubmit={this.handleQueryfeedback}>
                <div className='modal-body'>
                  <div className='rating-box '>
                    <div className="row">
                      <div className='col-md-12'>
                        <div className='col'>
                          <p className='rating r-text'>
                            As a parent - do you think this product will help you ?
                          </p>
                        </div>
                        <div className='col'>
                          <Rating
                            name=""
                            starCount={5}
                            value={rating1}
                            onStarClick={this.onStarClick1feedback.bind(this)}
                          />
                        </div>
                      </div>
                      <div className='col-md-12'>
                        <div className='col'>
                          <p className='rating r-text'>
                            How easy was it to navigate ? Flow / Categories / Layout /
                          </p>
                        </div>
                        <div className='col'>
                          <Rating
                            name=""
                            value={rating}
                            onStarClick={this.onStarClickfeedback.bind(this)}
                            starCount={5}
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className='form-group'>
                          <label className='login-label r-text'>
                            What other feature will help even more?                     </label>
                          <input
                            required
                            onChange={(e) => this.handleChangefeedback(e)}
                            name="feature" className='form-control'
                            type='text' />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className='form-group'>
                          <label className='login-label r-text'>
                            What more should we include to help your decision making ?                 </label>
                          <input
                            required
                            name="decision"
                            onChange={(e) => this.handleChangefeedback(e)}
                            className='form-control' type='text' />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className='form-group'>
                          <label className='login-label r-text'>
                            What other verticals / Needs we should add ?               </label>
                          <input
                            required
                            name="verticals" onChange={(e) => this.handleChangefeedback(e)}
                            className='form-control' type='text' />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className='form-group'>
                          <label className='login-label r-text'>
                            What is the one suggestion you will give for founders of BeWise?            </label>
                          <input
                            required
                            name="suggession" onChange={(e) => this.handleChangefeedback(e)}
                            className='form-control' type='text'
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className='form-group'>
                          <label className='r-text '>What other topics in "review" will help you in making an even better decision?  </label>
                          <textarea
                            required
                            className='form-control'
                            id='message'
                            rows='4'
                            cols='50'
                            name="message"
                            onChange={(e) => this.handleChangefeedback(e)}

                          ></textarea>
                        </div>
                      </div>

                    </div>


                  </div>

                </div>
                <div className='modal-footer' style={{ border: 'none' }}>
                  <button type='button' className='btn  btn-default' data-dismiss='modal' aria-label='Close'>
                    Cancel </button>
                  <input
                    type='submit'
                    name='submit'
                    value='Submit'
                    className='btn btn-primary'
                  />
                </div>
              </form>
            </div>
          </div>
        </div>

        <div
          className='modal fade review-modal'
          id='postQueryModal'
        >
          <div className='modal-dialog model-box modal-md' >
            <form method='post'
              onSubmit={this.handleQuery}
              autoComplete='off'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h3 className='modal-title r-text'>
                    Contact Us
                  </h3>
                  <button
                    type='button'
                    className='close'
                    data-dismiss='modal'
                    aria-label='Close'
                  >
                    <span aria-hidden='true'>&times;</span>
                  </button>
                </div>
                <div className='modal-body'>

                  <div className="row contactus-form">
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label className='login-label r-text'>
                          Name<span style={{ color: 'red' }}>*</span>
                        </label>
                        <input className='form-control'
                          value={this.state.q_name}
                          name="q_name"
                          onChange={this.handleChange}
                          type='text' placeholder="Enter your name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label className='login-label r-text'>
                          Query Type<span style={{ color: 'red' }}>*</span>
                        </label>
                        <select name="q_type" onChange={this.handleChange} className="form-control contactus-formli">
                          <option value="">Select</option>
                          <option value="1">Have a query</option>
                          <option value="2">Have a suggestion</option>
                          <option value="3">Need a help</option>
                          <option value="4">Others</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label className='login-label r-text'>
                          Email<span style={{ color: 'red' }}>*</span>
                        </label>
                        <input className='form-control' type='text'
                          value={this.state.q_email_id}
                          name="q_email_id"
                          onChange={this.handleChange}
                          placeholder="Enter your email" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className='form-group'>
                        <label className='login-label r-text'>
                          Phone Number
                        </label>
                        <input className='form-control' type='text'
                          value={this.state.q_phone_no}
                          name="q_phone_no"
                          onChange={this.handleChange}
                          placeholder="Enter your Phone Number " />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className='form-group'>
                        <label className='login-label r-text'>
                          Query From<span style={{ color: 'red' }}>*</span>
                        </label>
                        <select name="user_type" className="form-control contactus-formli"
                          onChange={this.handleChange}>
                          <option value="">Select</option>
                          <option value="1">Partner</option>
                          <option value="2">Parent</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='form-group'>
                        <label className='login-label r-text'>
                          Subject<span style={{ color: 'red' }}>*</span>
                        </label>
                        <input className='form-control' type='text'
                          value={this.state.q_subject}
                          name="q_subject"
                          onChange={this.handleChange}
                          placeholder="Enter subject" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='form-group'>
                        <label className='r-text '>Comments<span style={{ color: 'red' }}>*</span>
                        </label>
                        <textarea
                          className='form-control'
                          id='message-text'
                          name="q_comments"
                          value={this.state.q_comments}
                          onChange={this.handleChange}
                          rows='4'
                          cols='50'
                        ></textarea>
                      </div>
                    </div>

                  </div>

                </div>
                <div className='modal-footer' style={{ border: 'none' }}>
                  <button type='button' className='btn btn-default' data-dismiss='modal' aria-label='Close'>

                    Cancel
                  </button>
                  <button type='submit' className='btn btn3 btn-primary' >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

      </React.Fragment >
    );
  }
}

export default HeaderV1;

